import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// used to show the progress bar inside the container management columns
const ProgressCell = ({ row }) => {
  const occupied = row?.original?.capacity_occupied || 0;
  const allowed = row?.original?.capacity_allowed || 0;

  const progress =
    allowed > 0 ? Math.round((occupied / allowed) * 100) : 0;

  return (
    <Box sx={{ width: "80%" }}>
      {/* Top line: occupied / allowed */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 ,whiteSpace: "nowrap"}}>
        <Typography  className="text-12" variant="body2" color="textSecondary">
          {occupied.toLocaleString()} / {allowed.toLocaleString()}
        </Typography>
        <Typography  className="text-12" variant="body2" color="textSecondary">
          {progress}%
        </Typography>
      </Box>

      {/* Progress bar */}
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 8,
          borderRadius: 5,
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#f97316",
          },
        }}
      />
    </Box>
  );
};

export default ProgressCell;
